import {  execQuery, useQuery } from "./api";
import React from "react";
import { SqlLineChart } from "./components/SqlLineChart";
import { openExportUsersModal } from '@/components/elements/ExportUsersModal';
import { Button, Select } from "@/components/elements";

export function CampaignReport() {
  const [campaign, setCampaign] = React.useState('');
  const campaigns = useCampaigns();

  const exportUsers = (campaign: string) => {
    let type: 'include' | 'exclude' | '' = '';
    const userMap = new Set<string>();
    openExportUsersModal({
      beforeCsv: async(data) => {
        return data.filter(d => {
          if(type === 'exclude') {
            return userMap.has(d.id) === false;
          } else {
            return userMap.has(d.id) === true;
          }
        })
      },
      onDownload: async() => {
        const users = await getUsersForCampaign(campaign);
        if(!users?.length) {
          alert('Error: No users found for campaign.');
          throw new Error('No users found for campaign.');
        }
        for(let user of users) {
          userMap.add(user.user_id)
        }
      },
      headerContent: <>
        <UserExportHeader onType={t => type = t} campaign={campaign}/>
      </>
    })
  }

  return <>
    <div>
      <div className="flex flex-col p-4" style={{gap: 8}}>
        <select value={campaign} onChange={(e) => setCampaign(e.target.value)}>
        <option value="">Select a campaign</option>
          {campaigns.result.map(item => {
            const date = new Date(item.start_ts);
            return <React.Fragment key={item.utm_campaign}>
              <option value={item.utm_campaign}>{date.toLocaleDateString()} : {item.utm_campaign} - x{item.count}</option>
            </React.Fragment>
          })}
        </select>

        {campaign ? (<SqlLineChart key={campaign} startTime={0} endTime={0}>
          {`
            select
              time_bucket(INTERVAL '1m', epoch_ms(start_ts)) AS time,
              CASE WHEN user_id is not null THEN 'account' ELSE 'guest' END as label,
              count(1) as count,
            from spans
            where utm_campaign = '${campaign}' and label = 'article' and epoch_ms(start_ts) < now()
            group by CASE WHEN user_id is not null THEN 'account' ELSE 'guest' END, time
            order by time
          `}
          </SqlLineChart>) : null}
          <Button disabled={!campaign} size="sm" clickEvent={() => exportUsers(campaign)}>Export Users</Button>

      </div>

    </div>

  </>
}

function useCampaigns() {
  const sql = `
    select
      spans.utm_campaign,
      mean(start_ts) as start_ts,
      count(1) as count,
    from spans where label = 'article' and spans.utm_campaign is not null
    group by spans.utm_campaign
    order by start_ts desc
  `;

  return useQuery<{utm_campaign: string, start_ts: number, count: number}>(() => [sql]);
}

async function getUsersForCampaign(campaign: string) {
  return await execQuery<{user_id: string}>({
    sql: `select distinct user_id from spans where utm_campaign = ?`,
    args: [campaign]
  });
}

interface UserExportHeaderProps {
  campaign: string;
  onType: (type: 'include' | 'exclude') => void;
}

function UserExportHeader(props: UserExportHeaderProps) {
  const [type, setType] = React.useState<'include' | 'exclude'>('include');

  const options = React.useMemo(() => {
    const options: {label: string, value: string}[] = [
      {label: `Include only users who interacted with ${props.campaign} campaign.`, value: 'include'},
      {label: `Exclude users who interacted with the ${props.campaign} campaign.`, value: 'exclude'},
    ];

    return options;
  }, []);

  React.useEffect(() => {
    props.onType(type);
  }, [type]);

  return <>
    Campaign Filter: 
    <Select
      size="small"
      value={type}
      changeEvent={e => setType(e.target.value as any)}
      options={options}/>
  </>
}